import React , {useState, useEffect} from 'react'
import { Player, Controls } from "@lottiefiles/react-lottie-player";




function LottiPlayer() {

    const [windowWidth, setWindowWidth] = useState();
    
    useEffect(() => {
        if (window.innerWidth > 700){
             setWindowWidth(500);
            }else if (window.innerWidth <= 375 ) {
                setWindowWidth(280);
        } else {
          setWindowWidth(window.innerWidth);
        }
    }, [])
    

  return (
    <div className={``}>
      <Player
        autoplay
        src={`https://tabclixdata.s3.ca-central-1.amazonaws.com/tabclix-profile-circle-graphic.json`}
        style={{ width: `250px` }}
        keepLastFrame
      >
        <Controls visible={false} />
      </Player>
    </div>
  );
}

export default LottiPlayer